import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { PageHeaderFoot, Prompt, Button, AutoTableContainer, Table, Pagination } from 'kts-xui';
import { AdvancedSearch, KtsForm } from 'kts-components';
import AddModal from './UI.AddModal';
import { Icon, Tooltip } from 'antd';
import { MyStore } from 'kts-platform-frame/redux';
import './index.less';
import moment from 'moment';

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {
    columns = [
        {
            title: '发放状态',
            dataIndex: 'state',
            width: 90,
            key: 'state',
            render: (text, record) => {
                if (text === -1) {
                    return <Tooltip title={record.stateMsg}><span style={{ color: '#FF5F58' }}>失败</span></Tooltip>;
                }
                if (text === 0) {
                    return <span style={{ color: '#0074FF' }}>发放中</span>;
                }
                if (text === 1) {
                    return <span style={{ color: '#0074FF' }}>成功</span>;
                }
            }
        }, {
            title: '备注名称',
            dataIndex: 'remarkName',
            key: 'remarkName',
            width: 200
        }, {
            title: 'DID',
            dataIndex: 'did',
            width: 340,
            key: 'did',
        }, {
            title: '申请时间',
            width: 170,
            dataIndex: 'applicationDate',
            key: 'applicationDate',
            render: (text) => {
                return moment(text).format('YYYY-MM-DD HH:mm');
            }
        }, {
            title: '代理人',
            dataIndex: 'agent',
            width: 100,
            key: 'agent',
        }, {
            title: '申请理由',
            dataIndex: 'applicationReason',
            key: 'applicationReason',
        }, {
            title: '操作',
            dataIndex: 'isDefault',
            width: 150,
            key: 'isDefault',
            render: (text, record) => {
                const btns = [];
                if (text === true && record.state === 1) {
                    btns.push(<span style={{ color: 'grey' }}>默认</span>);
                }
                if (text === false && record.state === 1) {
                    btns.push(<a onClick={() => { this.setDefault(record.did); }}>设为默认</a>);
                }
                if (record.state === 0) {
                    btns.push(<a onClick={() => { this.reSubmit(record.did); }}>重新提交</a>);
                }
                return btns.map((item, key) => {
                    return <span style={{ marginRight: 8 }} key={key}>{item}</span>;
                });
            }
        },
    ];
    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    setDefault = id => {
        ModulesAction.setDefault(id);
    }
    reSubmit = id => {
        ModulesAction.reSubmit(id);
    }
    topExpand = () => {
        return (
            <AdvancedSearch
                tableKey="didtable"
                width={480}
                height={44}
                compact={true}
                defaultKey="did"
                placeholder="请输入"
                searchFormSubmit={this.onSearch}
            >
                <KtsForm
                    labelCol={9}
                    wrapperCol={15}
                    labelAlign="left"
                    compact={true}
                    schema={{
                        type: 'object',
                        properties: {
                            remarkName: {
                                type: 'string',
                                title: '备注名称',
                            },
                            did: {
                                type: 'string',
                                title: 'DID',
                            },
                            agent: {
                                type: 'string',
                                title: '代理人',
                            },
                            state: {
                                type: 'string',
                                title: '发放状态',
                                enum: [
                                    {
                                        label: '成功',
                                        value: 1,
                                    },
                                    {
                                        label: '失败',
                                        value: 0,
                                    },
                                ],
                            },
                        },
                    }}
                >
                </KtsForm>
            </AdvancedSearch>
        );
    }
    openModal = () => {
        this.modulesState.showModal = true;
        this.setModulesState();
    }
    componentDidMount() {
        const data = {
            ...this.modulesState.pageMeta
        };
        ModulesAction.getDidList(data);
    }
    onPageChange = (page, pageSize) => {
        this.modulesState.pageMeta.pageNum = page;
        this.modulesState.pageMeta.pageSize = pageSize;
        this.setModulesState();
        this.onRefresh();
    }
    onRefresh = () => {
        const params = {
            ...this.modulesState.params,
            ...this.modulesState.pageMeta,
        };
        ModulesAction.getDidList(params);
    }
    onSearch = (data = {}) => {
        console.log(data);
        this.modulesState.params = data;
        this.setModulesState();
        const params = {
            ...data,
            ...this.modulesState.pageMeta,
            pageNum: 1
        };

        ModulesAction.getDidList(params);
    }
    render() {
        const dataSource = this.modulesState.list;
        const { pageMeta } = this.modulesState;
        const { user } = MyStore.instance.getState();
        return (
            <div style={{ height: 'calc(100vh - 140px)', display: 'flex', flexDirection: 'column' }}>
                <div style={{ flex: 'none', position: 'relative', zIndex: 1 }} className="special">
                    <PageHeaderFoot
                        expandLeft={this.topExpand()}
                        expandRight={[
                            <Prompt key='0'><Icon type="info-circle" />DAP企业/机构:{user.userInfo.companyName}</Prompt>,
                            <Button key='1' type="primary" onClick={this.openModal}>新增申请</Button>,
                        ]}
                        onRefresh={this.onRefresh}
                    >

                    </PageHeaderFoot>
                </div>
                <AutoTableContainer style={{ flex: 1, padding: '0 20px', backgroundColor: '#efefef' }} >
                    <Table
                        bordered={true}
                        dataSource={dataSource}
                        columns={this.columns}
                        scroll={{ x: '1200',y:'max-content' }}
                        pagination={false}
                    />

                </AutoTableContainer>
                {/* <Pagination onChange={this.onPageChange} style={{ padding: '16px 0', flex: 'none', background: 'white', textAlign: 'center' }} total={pageMeta.total} pageSize={pageMeta.pageSize} current={pageMeta.pageNum} showSizeChanger={true} /> */}
                {
                    this.modulesState.showModal && <AddModal onSuccess={this.onSearch} />
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/DiDManager/UI.Components.tsx